class CloudflareTurnstileContainer extends HTMLElement {
  connectedCallback() {
    if (!this.isConnected) {
      return;
    }

    if (!this.hasBeenSetup) {
      const element = this;
      setTimeout(() => {
        element.ensureCloudflareTurnstileRendered();
      }, 500);
    }
  }

  get turnstileElement() {
    return this.querySelector(`.cf-turnstile`);
  }

  get hasBeenSetup() {
    return (
      this.querySelector(`input[type=hidden][name=cf-turnstile-response]`) !=
      null
    );
  }

  ensureCloudflareTurnstileRendered() {
    if (this.hasBeenSetup) {
      return;
    }
    window.turnstile.render(this.turnstileElement);
  }
}

if (!window.customElements.get("cloudflare-turnstile-container")) {
  window.customElements.define(
    "cloudflare-turnstile-container",
    CloudflareTurnstileContainer,
  );
}
